import { TRACKING_ACTION } from 'contexts/AnalyticsContext/Constants';
import { propertyNames } from 'contexts/AnalyticsContext/utils';
import { trackEvent } from 'lib/ui-analytics';
import { getItineraryCardInfo } from 'lib/ui-analytics/utils';

export const utagRatingTooltip = (cruiseDetails, container, brand) => {
  if (cruiseDetails) {
    const interaction = createItineraryInteraction(cruiseDetails, container, brand);
    trackEvent(interaction);
  }
};

const createItineraryInteraction = (cruiseDetails, container, brand) => {
  const {
    masterSailing,
    lowestPriceSailing,
    id,
  } = cruiseDetails;

  return {
    eventType: TRACKING_ACTION.INTERACTION,
    interaction: container, 
    itineraryCardInfo: getItineraryCardInfo(id, masterSailing, lowestPriceSailing),
    [propertyNames[brand].productSku]: [masterSailing.itinerary.code],
  };
};
